import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteExchangeRate } from '../../../../actions';

const ExhcangeRateDeleteButton = ({
  dispatchDeleteExhcangeRate,
  exchangeRateId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteExhcangeRate({ exchangeRateId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

ExhcangeRateDeleteButton.propTypes = {
  dispatchDeleteExhcangeRate: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  exchangeRateId: PropTypes.number.isRequired,
};

ExhcangeRateDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteExhcangeRate: deleteExchangeRate,
};

export default connect(null, mapDispatchToProps)(ExhcangeRateDeleteButton);
